// extracted by mini-css-extract-plugin
export var meganumber = "pagedata-module--meganumber--MlhDQ";
export var minitext = "pagedata-module--minitext--IL6YX";
export var pagedata = "pagedata-module--pagedata--Llqkc";